import React, { Fragment } from "react";
import { Title } from 'react-admin';
import {useState, useRef} from 'react';
import { Link } from "react-router-dom";
// import Logo from "./dist/images/tc-logo-fordarkbg.png";
// import bgImg from "./dist/images/bg-plain.jpg";
import TC_Explainer_Video from "./dist/videos/TC_Home_Video_V3.mp4";
import TC_Platform_Demo from "./dist/videos/Techcomb_Web_Platform_Demo.mp4";
import screenfull from 'screenfull';
import ReactPlayer from 'react-player';
import Container from '@mui/material/Container';
import ControlIcons from './components/ControlIcons';

import "./styles/Home.css";
import "./dist/css/style.min.css";


const format = (seconds) => {
  if (isNaN(seconds)) {
    return '00:00'
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, "0");

  if (hh) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`
  } else {
      return `${mm}:${ss}`
  }
};


function VideoSection({ src, caption }) {
  const [playerstate, setPlayerState] = useState({
    playing: false,
    muted: false,
    volume: 0.5,
    playerbackRate: 1.0,
    played: 0,
    seeking: false,
  });

  const { playing, muted, volume, playerbackRate, played, seeking } = playerstate;
  const playerRef = useRef(null);
  const playerDivRef = useRef(null);

  const handlePlayAndPause = () => setPlayerState({ ...playerstate, playing: !playing });
  const handleMuting = () => setPlayerState({ ...playerstate, muted: !muted });

  const handleVolumeChange = (e, newValue) =>
    setPlayerState({ ...playerstate, volume: parseFloat(newValue / 100), muted: newValue === 0 });

  const handleVolumeSeek = (e, newValue) =>
    setPlayerState({ ...playerstate, volume: parseFloat(newValue / 100), muted: newValue === 0 });

  const handlePlayerRate = (rate) => setPlayerState({ ...playerstate, playerbackRate: rate });

  const handleFullScreenMode = () => screenfull.toggle(playerDivRef.current);

  const handlePlayerProgress = (state) => {
    if (!playerstate.seeking) setPlayerState({ ...playerstate, ...state });
  };

  const handlePlayerSeek = (e, newValue) => {
    setPlayerState({ ...playerstate, played: parseFloat(newValue / 100) });
    playerRef.current?.seekTo(parseFloat(newValue / 100));
  };

  const handlePlayerMouseSeekDown = () => setPlayerState({ ...playerstate, seeking: true });

  const handlePlayerMouseSeekUp = (e, newValue) => {
    setPlayerState({ ...playerstate, seeking: false });
    playerRef.current?.seekTo(newValue / 100);
  };

  const currentPlayerTime = playerRef.current ? playerRef.current.getCurrentTime() : "00:00";
  const movieDuration = playerRef.current ? playerRef.current.getDuration() : "00:00";
  const playedTime = format(currentPlayerTime);
  const fullMovieTime = format(movieDuration);

  return (
    <div className="row align-items-center justify-content-center">
      <div className="col-lg-1 my-1 py-1" />
      <div className="col-lg-10 my-1 py-1">
        <Container>
          <div className="playerDiv" ref={playerDivRef}>
            <ReactPlayer
              width="100%"
              height="100%"
              ref={playerRef}
              url={src}
              playing={playing}
              volume={volume}
              playbackRate={playerbackRate}
              onProgress={handlePlayerProgress}
              muted={muted}
            />
            <div className="playerControls">
              <ControlIcons
                key={volume.toString()}
                playandpause={handlePlayAndPause}
                playing={playing}
                muting={handleMuting}
                muted={muted}
                volumeChange={handleVolumeChange}
                volumeSeek={handleVolumeSeek}
                volume={volume}
                playerbackRate={playerbackRate}
                playRate={handlePlayerRate}
                fullScreenMode={handleFullScreenMode}
                played={played}
                onSeek={handlePlayerSeek}
                onSeekMouseUp={handlePlayerMouseSeekUp}
                onSeekMouseDown={handlePlayerMouseSeekDown}
                playedTime={playedTime}
                fullMovieTime={fullMovieTime}
                seeking={seeking}
              />
            </div>
          </div>
          {caption && <p className="font-sm">{caption}</p>}
        </Container>
      </div>
      <div className="col-lg-1 my-1 py-1" />
    </div>
  );
}


function Home() {
  document.title = "TechComb Inc."; 

  return (
    <>
    <Title title="TechComb Inc." />
    {/*!-- ============================================================== -->
    <!-- Main wrapper - style you can find in pages.scss --
  <!-- ============================================================== -->*/}
    <div className="page-wrapper overflow-hidden home headerContainer">
      <div className="row">
        <div className="col-lg-12">
           <h1>
            Your One Stop Shop for Artificial Intelligence Powered Automation
          </h1> 
          <h2>
          <span className="fw-bold"> We offer customized, AI-powered, robotic automation solutions for manufacturing, surveillance, and service sectors.  </span>
          </h2>
          <br></br>
          <br></br>
          <div className="down-btn dm-btn">
            <Link to="/Login" className="btn btn-info mb-10 px-5 py-3"> Login</Link>
            {" "}
            <Link to="/ContactUs" className="btn btn-outline-info mb-10 px-5 py-3"> Request A Demo </Link>
            <br></br>
            <br></br>
          </div> 
        </div>
      </div>      
    </div>      


    
    <div className="row align-items-center justify-content-center" >
        <div className="col-lg-1 my-1 py-1"></div>
        <div className="col-lg-10 my-1 py-1">
          <Container>
              <VideoSection src={TC_Explainer_Video} caption="Prepared by TechComb Inc." />   
          </Container>
        </div>
        <div className="col-lg-1 my-1 py-1"></div>

        <div className="col-lg-1 my-1 py-1"></div>
        {/* <div className="Container text-center">
          <h2>See the Platform in Action</h2>
        </div> */}
        <div className="col-lg-1 my-1 py-1"></div>
        {/* <div className="col-lg-10 my-1 py-1">
          <Container>
              <VideoSection src={TC_Platform_Demo} caption="TechComb Web Platform Demo" />   
          </Container>
        </div> */}
        <div className="col-lg-1 my-1 py-1"></div>
    </div>

      <div id="main-wrapper" className="overflow-hidden">
        <div className="Container text-center my-3 py-3">
          <h2>
              Build new or upgrade existing automation for your workflow with our AI technology.
          </h2>
        </div>
        
        <div className="container">
          <div className="row my-2 py-2" >
            <h1 className="text-center" >
              <span className="font-lg font-bold">We Offer Custom Solutions for</span>
            </h1>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="card shadow rounded border-0 text-center p-4 card-height" >
                <div className="card-body">
                  <i className="bi bi-eye text-info display-6"></i>
                  <h5 className="card-title mt-3 font-bold">AI Vision</h5>
                  <p className="text-muted font-sm-md">Machine vision recharged with machine learning to deliver rapid and wide-range visual detection</p>
                </div>
              </div>
            </div> 

            <div className="col-lg-4 col-md-6 d-flex">
              <div className="card shadow rounded border-0 text-center p-4 card-height" >
                <div className="card-body">
                  <i className="bi bi-robot text-info display-6"></i>
                  <h5 className="card-title mt-3 font-bold">e-Commerce Data Analytics</h5>
                  <p className="text-muted font-sm-md">Intelligent pricing and product placement strategy support for dynamic market variations</p>
                </div>
              </div>
            </div> 

            <div className="col-lg-4 col-md-6 d-flex">
              <div className="card shadow rounded border-0 text-center p-4 card-height">
                <div className="card-body">
                  <i className="bi bi-cpu text-info display-6"></i>
                  <h5 className="card-title mt-3 font-bold">ML Model Integration</h5>
                  <p className="text-muted font-sm-md">Streamlined machine learning model development and deployment in automation applications</p>
                </div>
              </div>
            </div>

        
            <div className="text-center py-4">
              <Link to="/ContactUs" className="btn-teal"> Contact Us </Link>
            </div>
   
            </div>      
          </div>
          
      </div>
    </>
  );
  }

export default Home;